// @ToDo: add constructor
export class CsvFile {
  public fileName: string;
  public fileType: string;
  public fileData: string;
}
